<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <div>
    <v-text-field v-show="false" v-model="actions" :rules="rules" />

    <v-card v-for="(actionValue, index) in actions" :key="actionValue.key" class="card-action mb-5" color="secondary" outlined min-width="100%">
      <v-btn class="float-right mt-4 mr-3" right icon @click="removeAction(index)">
        <v-icon> delete </v-icon>
      </v-btn>

      <FormAction :action.sync="actions[index]" class="mt-n3" :workspaces="workspaces" :index="index" :actions-module-configuration="getActionsModuleConfig(actionValue.type)" />
    </v-card>
    <v-row align-content="center">
      <v-col offset="4" cols="4">
        <v-select
          v-model="type"
          outlined
          item-text="name"
          item-value="value"
          :items="actionsOptions"
          menu-props="light"
          color="blue"
          label="Ajouter une action"
          @change="addAction"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
import { ref, computed, watch, nextTick } from 'vue';
import { useStore } from 'vue2-helpers/vuex';

import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import FormAction from './RuleForms/FormAction';

const props = defineProps({
  value: { type: Array, default: () => [] },
  workspaces: { type: Array, default: null },
  conditions: { type: Array, default: null },
  actionsModulesConfiguration: { type: Object, default: () => {} },
  customActionsOptions: { type: Array, default: () => [] }
});

const store = useStore();

const actions = ref(props.value || []);
const timestamp = ref(moment().unix());
const type = ref('');
const rules = ref([v => !!(v && v.length)]);
// TEST TO DEPLOY ON CLOUDFLARE BY BRANCH

const isDisabledPinItem = computed(() => {
  if (props.conditions && props.conditions.length === 0) {
    return true;
  }

  if (props.conditions && !(props.conditions[0].hasFilter || props.conditions[0].hasQuery)) {
    return true;
  }

  return false;
});

const actionsOptions = computed(() => {
  const options = [
    { value: 'promote', name: 'Épingler un produit', disabled: isDisabledPinItem.value },
    { value: 'hide', name: 'Cacher un produit' },
    { value: 'promCategory', name: 'Promouvoir une catégorie' },
    { value: 'changeSortCriterion', name: 'Changer le critère de tri', singleValued: false },
    { value: 'redirection', name: 'Redirection' },
    { value: 'applyFilter', name: 'Appliquer un filtre' },
    { value: 'displayContent', name: 'Afficher le contenu' },
    { value: 'customJSON', name: 'Données JSON', singleValued: true },
    { value: 'customHTML', name: 'Code HTML', singleValued: true },
    ...props.customActionsOptions.map(option => ({ ...option })) // Retrieved from API: contains actions specific to the current project only
  ];

  options.forEach(option => {
    if (option.singleValued) {
      option.disabled = !!(actions.value.some(a => a.type === option.value));
    }
  });

  const hasRedirection = actions.value.some(a => a.type === 'redirection');
  if (hasRedirection) {
    options.forEach(option => {
      option.disabled = true;
    });
  }

  return options;
});

// eslint-disable-next-line no-undef
const emit = defineEmits(['input']);

watch(
  actions.value,
  val => {
    // Updates v-model on the parent
    emit('input', val || null);
  },
  { deep: true }
);

actions.value.forEach(a => {
  if (!a.key) {
    a.key = uuidv4();
  }
});

const addAction = val => {
  const action = {};

  action.key = uuidv4();

  action.type = val;

  switch (val) {
    case 'promote':
      action.position = 1;
      action.availableSearchProduct = true;
      break;
    case 'promCategory':
      action.score = 1;
      action.values = [];
      action.facet = null;
      break;
    case 'applyFilter':
      action.facet = null;
      action.operator = null;
      action.values = [];
      break;
    case 'robotsIndex':
      action.robotsIndex = true; // Default to index
      break;
    case 'titleOverwrite':
      action.title = '';
      break;
    default:
  }

  actions.value.push(action);

  nextTick(() => {
    type.value = '';
  });
};

const getActionsModuleConfig = moduleType => (props.actionsModulesConfiguration && props.actionsModulesConfiguration.hasOwnProperty(moduleType) ? props.actionsModulesConfiguration[moduleType] : null);

const removeAction = index => {
  timestamp.value = moment().unix();
  actions.value.splice(index, 1);
};

const currentContexts = computed(() => store.state.rules.contextsSelect);

const isLabalaguere = computed(() => store.state.environment.PROJECT === 'labalaguere');

const updateActionsByContexts = () => {
  // *  SOME ACTIONS SHOULD HAVE RELATION BETWEEN CONTEXT AS EXAMPLE PIN A PRODUCT !
  // *  TO FIND CONTENT (EX: PRODUCT) WE USE THE CONTEXT TO SEARCH BY CORRECT PARTNER PRODUCT
  // *  SO WHEN WE UPDATE THE CONTEXT WE MUST REMOVE ACTIONS WHICH ARE ASSOCIATED A OLD CONTEXT
  if (currentContexts.value.length !== 0 && !isLabalaguere.value) {
    Object.entries(actions.value ? actions.value : []).map(([index, action]) => {
      if (action.hasOwnProperty('item') && !currentContexts.value.includes(action.item.context)) {
        actions.value.splice(index, 1);
      }
    });
  }
};

watch(currentContexts, () => {
  updateActionsByContexts();
});
</script>

<style>
.card-action.v-card.secondary {
  border: 1px solid #fff !important;
}
</style>
